import Chart from 'react-apexcharts';
import { useEffect, useState } from 'react';

export const ChartBar = ({ title = '', labels = [], data = [], currency = '' }) => {
    const [curr, setCurr] = useState('');

    const state = {
        options: {
            chart: {
                height: 360,
                type: 'bar',
                stacked: true,
                zoom: {
                    enabled: false,
                },
                toolbar: {
                    show: false
                },
            },
            labels,
            title: {
                text: title,
            },
            colors: ['#7F56D9', '#9E77ED', '#F4EBFF'],
            plotOptions: {
                bar: {
                    distributed: true,
                    dataLabels: {
                        position: 'top',
                    },
                    columnWidth: '65%',
                },
            },
            dataLabels: {
                enabled: true,
                formatter: (val) => `${curr} ${val}`,
                textAnchor: 'end',
                distributed: false,
                offsetY: -20,

                style: {
                    fontSize: '12px',
                    colors: ['#7f56d9', '#a98ce6', '#b89feb'],
                },
            },

            xaxis: {
                axisBorder: {
                    show: false,
                },
                axisTicks: {
                    show: false,
                },
                tooltip: {
                    enabled: false,
                },
            },
            yaxis: {
                axisBorder: {
                    show: false,
                },
                axisTicks: {
                    show: false,
                },
                labels: {
                    show: false,
                },
            },
            tooltip: {
                style: {
                    fontSize: '12px',
                },
                y: {
                    title: {
                        formatter: () => null,
                    },
                },
            },
            legend: { show: false },
            grid: {
                borderColor: '',
            },
        },
        series: [{ data }],
    };

    useEffect(() => {
        if (currency) {
            setCurr(currency);
        }
    }, [currency]);

    return <Chart options={state.options} series={state.series} type="bar" height={300} />;
};
